import { ISimpleIcon } from './types';

import {
    faGrinHearts as fadGrinHearts,
    faFileInvoice as fadFileInvoice,
    faBullhorn as fadBullhorn,
} from '@fortawesome/pro-duotone-svg-icons';

import {
    faSlack as fabSlack,
    faJira as fabJira,
    faGithub as fabGithub,
    faTrello as fabTrello,
    faMicrosoft as fabMicrosoft,
    faMarkdown as fabMarkdown,
} from '@fortawesome/free-brands-svg-icons';

import {
    faCog as fasCog,
    faEllipsisV as fasEllipsisV,
    faCaretDown as fasCaretDown,
    //faTimes as fasTimes,
    faUser as fasUser,
    faUsers as fasUsers,
    faUpload as fasUpload,
    faCircle as fasCircle,
    faStar as fasStar,
    faStarHalf as fasStarHalf,
    faUserFriends as fasUserFriends,
    faThumbtack as fasThumbtack,
    faUserTimes as fasUserTimes,
    faUnlockAlt as fasUnlockAlt,
    faCertificate as fasCertificate,
    faFileSpreadsheet as fasFileSpreadsheet,
    faTh as fasTh,
    faKey as fasKey,
    faEye as fasEye,
    faMagic as fasMagic,
    faHandPaper as fasHandPaper,
    faChalkboardTeacher as fasChalkboardTeacher,
    faBinoculars as fasBinoculars,
    faLayerGroup as fasLayerGroup,
    faPlug as fasPlug,
    faCommentCheck as fasCommentCheck,
    faCrown as fasCrown,
    faExclamationTriangle as fasExclamationTriangle,
    faList as fasList,
    faListOl as fasListOl,
    faUserLock as fasUserLock,
    faGripVertical as fasGripVertical,
    faShareSquare as fasShareSquare,
    faFilter as fasFilter,
    faSquare as fasSquare,
    faBars as fasBars,
    faSparkles as fasSparkles,
    faFileLines as fasFileLines,
    faBold as fasBold,
    faItalic as fasItalic,
    faUnderline as fasUnderline,
    faStrikethrough as fasStrikethrough,
    faCode as fasCode,
    faParagraph as fasParagraph,
    faH1 as fasH1,
    faH2 as fasH2,
    faH3 as fasH3,
    faH4 as fasH4,
    faH5 as fasH5,
    faQuoteLeft as fasQuoteLeft,
    faHorizontalRule as fasHorizontalRule,
    faRotateLeft as fasRotateLeft,
    faRotateRight as fasRotateRight,
    faListCheck as fasListCheck,
    faNoteSticky as fasNoteSticky,
    faCheckCircle as fasCheckCircle,
    faShieldAlt as fasShieldAlt,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faBold as faslBold,
    faItalic as faslItalic,
    faUnderline as faslUnderline,
    faStrikethrough as faslStrikethrough,
    faCode as faslCode,
    faParagraph as faslParagraph,
    faH1 as faslH1,
    faH2 as faslH2,
    faH3 as faslH3,
    faH4 as faslH4,
    faH5 as faslH5,
    faQuoteLeft as faslQuoteLeft,
    faHorizontalRule as faslHorizontalRule,
    faRotateLeft as faslRotateLeft,
    faRotateRight as faslRotateRight,
    faListCheck as faslListCheck,
    faList as faslList,
    faListOl as faslListOl,
    faImage as faslImage,
    faPlus as faslPlus,
    faLink as faslLink,
    faArrowUpRightFromSquare as faslArrowUpRightFromSquare,
    faLinkSlash as faslLinkSlash,
    faVideo as faslVideo,
    faCommentLines as faslCommentLines,
    faCheck as faslCheck,
    faXmark as faslXmark,
    faFloppyDisk as faslFloppyDisk,
    faPenToSquare as faslPenToSquare,
} from '@fortawesome/sharp-light-svg-icons';

import {
    faBold as fasrBold,
    faItalic as fasrItalic,
    faUnderline as fasrUnderline,
    faStrikethrough as fasrStrikethrough,
    faCode as fasrCode,
    faParagraph as fasrParagraph,
    faH1 as fasrH1,
    faH2 as fasrH2,
    faH3 as fasrH3,
    faH4 as fasrH4,
    faH5 as fasrH5,
    faQuoteLeft as fasrQuoteLeft,
    faHorizontalRule as fasrHorizontalRule,
    faRotateLeft as fasrRotateLeft,
    faRotateRight as fasrRotateRight,
    faListCheck as fasrListCheck,
    faList as fasrList,
    faListOl as fasrListOl,
} from '@fortawesome/sharp-regular-svg-icons';

import {
    faPlus as farPlus,
    faMinus as farMinus,
    faDotCircle as farDotCircle,
    faCircle as farCircle,
    faArrowsV as farArrowsV,
    faStar as farStar,
    faExpandWide as farExpandWide,
    faHomeAlt as farHomeAlt,
    faUserFriends as farUserFriends,
    faGlobe as farGlobe,
    faEye as farEye,
    faEyeSlash as farEyeSlash,
    faClock as farClock,
    faClockRotateLeft as farClockRotateLeft,
    faBell as farBell,
    faEnvelope as farEnvelope,
    faGraduationCap as farGraduationCap,
    faArchive as farArchive,
    faListTimeline as farListTimeline,
    faFolders as farFolders,
    faLevelUp as farLevelUp,
    faSearch as farSearch,
    faUnlock as farUnlock,
    faLock as farLock,
    faArrowRight as farArrowRight,
    faArrowLeft as farArrowLeft,
    faArrowUp as farArrowUp,
    faArrowDown as farArrowDown,
    faFolder as farFolder,
    faThumbsUp as farThumbsUp,
    faUser as farUser,
    faTag as farTag,
    faCircleInfo as farCircleInfo,
    faBars as farBars,
    faSliders as farSliders,
    faKeyboardLeft as farKeyboardLeft,
    faThumbTack as farThumbTack,
    faGripDots as farGripDots,
    faMessageDots as farMessageDots,
    faArrowUpWideShort as farArrowUpWideShort,
    faCircleXmark as farCircleXmark,
    faChevronUp as farChevronUp,
    faChevronsUp as farChevronsUp,
    faChevronDown as farChevronDown,
    faTimer as farTimer,
    faCircleExclamation as farCircleExclamation,
    faChartLineUp as farChartLineUp,
    faFaceSmile as farFaceSmile,
    faFaceMeh as farFaceMeh,
    faFaceFrown as farFaceFrown,
    faCaretRight as farCaretRight,
    faCircleEllipsis as farCircleEllipsis,
    faArrowsToLine as farArrowsToLine,
    faArrowsFromLine as farArrowsFromLine,
    faRotate as farRotate,
    faLightbulb as farLightbulb,
    faUserLock as farUserLock,
    faUserCheck as farUserCheck,
    faArrowRightToLine as farArrowRightToLine,
    faArrowRightLongToLine as farArrowRightLongToLine,
    faMagnifyingGlassPlus as farMagnifyingGlassPlus,
    faMagnifyingGlassMinus as farMagnifyingGlassMinus,
    faArrowsLeftRightToLine as farArrowsLeftRightToLine,
    faBook as farBook,
    faFilter as farFilter,
    faRectangleList as farRectangleList,
    faPause as farPause,
    faPlay as farPlay,
    faLinkSlash as farLinkSlash,
    faCloudArrowUp as farCloudArrowUp,
    faArrowsRotate as farArrowsRotate,
    faArrowUpToLine as farArrowUpToLine,
    faListUl as farListUl,
    faBold as farBold,
    faItalic as farItalic,
    faUnderline as farUnderline,
    faStrikethrough as farStrikethrough,
    faCode as farCode,
    faFileCode as farFileCode,
    faParagraph as farParagraph,
    faH1 as farH1,
    faH2 as farH2,
    faH3 as farH3,
    faH4 as farH4,
    faH5 as farH5,
    faFilePlusMinus as farFilePlusMinus,
} from '@fortawesome/pro-regular-svg-icons';

import {
    faPlus as falPlus,
    faCheckSquare as falCheckSquare,
    faSquare as falSquare,
    faCheck as falCheck,
    faTimesCircle as falTimesCircle,
    faTimes as falTimes,
    faCheckCircle as falCheckCircle,
    faInfoCircle as falInfoCircle,
    faExclamation as falExclamation,
    faExclamationTriangle as falExclamationTriangle,
    faMinusSquare as falMinusSquare,
    faBars as falBars,
    faPen as falPen,
    faStar as falStar,
    faSync as falSync,
    faArrowToLeft as falArrowToLeft,
    faArrowToRight as falArrowToRight,
    faPaperclip as falPaperclip,
    faColumns as falfaColumns,
    faAngleDown as falfaAngleDown,
    faGameBoardAlt as falfaGameBoardAlt,
    faPlusOctagon as falfaPlusOctagon,
    faCompress as falCompress,
    faExpand as falExpand,
    faBell as falBell,
    faEye as falEye,
    faEyeSlash as falEyeSlash,
    faGlobe as falGlobe,
    faUserFriends as falUserFriends,
    faThumbtack as falThumbtack,
    faEnvelope as falEnvelope,
    faSignOutAlt as falSignOutAlt,
    faServer as falServer,
    faKey as falKey,
    faIcons as falIcons,
    faCopy as falCopy,
    faUsersClass as falUsersClass,
    faSearch as falSearch,
    faLockAlt as falLockAlt,
    faUnlockAlt as falUnLockAlt,
    faUser as falUser,
    faUserCheck as falUserCheck,
    faEllipsisH as falEllipsisH,
    faEllipsisV as falEllipsisV,
    faTrashAlt as falTrashAlt,
    faEdit as falEdit,
    faPlayCircle as falPlayCircle,
    faFolders as falFolders,
    faCog as falCog,
    faUsers as falUsers,
    faFileImport as falFileImport,
    faFileSpreadsheet as falFileSpreadsheet,
    faFilter as falFilter,
    faCogs as falCogs,
    faCloud as falCloud,
    faReply as falReply,
    faPaperPlane as falPaperPlane,
    faUserHeadset as falUserHeadset,
    faUserCog as falUserCog,
    faSlidersVSquare as falSlidersVSquare,
    faFileInvoiceDollar as falFileInvoiceDollar,
    faCommentSmile as falCommentSmile,
    faBuilding as falBuilding,
    faBuildings as falBuildings,
    faGraduationCap as falGraduationCap,
    faPlusCircle as falPlusCircle,
    faGripHorizontal as falGripHorizontal,
    faLink as falLink,
    faLinkSlash as falLinkSlash,
    faUserSlash as falUserSlash,
    faFolder as falFolder,
    faShareAlt as falShare,
    faShareFromSquare as falShareFromSquare,
    faSquareKanban as falSquareKanban,
    faFileExport as falFileExport,
    faArrowRight as falArrowRight,
    faChartGantt as falChartGantt,
    faArrowsToLine as falArrowsToLine,
    faArrowsFromLine as falArrowsFromLine,
    faClone as falClone,
    faArrowUpWideShort as falArrowUpWideShort,
    faArrowDownFromLine as falArrowDownFromLine,
    faChevronsLeft as falChevronsLeft,
    faChevronsRight as falChevronsRight,
    faFileInvoice as falFileInvoice,
    faUserPlus as falUserPlus,
    faTag as falTag,
    faPaintBrushFine as falPaintBrushFine,
    faAlignJustify as falAlignJustify,
    faTimer as falTimer,
    faCalendarCircleMinus as falCalendarCircleMinus,
    faRectangleList as falRectangleList,
    faRocket as falRocket,
    faThumbsUp as falThumbsUp,
    faThumbsDown as falThumbsDown,
    faArrowsUpDown as falArrowsUpDown,
    faArrowsLeftRight as falArrowsLeftRight,
    faArrowProgress as falArrowProgress,
    faTrashCan as falTrashCan,
    faArrowsToDot as falArrowsToDot,
    faArrowDownLeftAndArrowUpRightToCenter as falArrowDownLeftAndArrowUpRightToCenter,
    faArrowUpRight as falArrowUpRight,
    faUpRight as falUpRight,
    faArrowsLeftRightToLine as falArrowsLeftRightToLine,
    faNoteSticky as falNoteSticky,
    faCommentPen as falCommentPen,
    faCrosshairs as falCrosshairs,
    faArrowTurnRight as falArrowTurnRight,
    faCodeCompare as falCodeCompare,
    faFileLines as falFileLines,
} from '@fortawesome/pro-light-svg-icons';

import {
    faSquarePlus as fatSquarePlus,
    faSlider as fatSlider,
    faSquare as fatSquare,
    faDownRight as fatDownRight,
    faUpRight as fatUpRight,
    faRocketLaunch as fatRocketLaunch,
    faTimes as fatTimes,
    faCommentPen as fatCommentPen,
} from '@fortawesome/pro-thin-svg-icons';

const iconList: ISimpleIcon = {
    // vuetify default icons
    'add-r': {
        icon: farPlus,
        classNames: ['far', 'plus'],
    },
    plusRegular: {
        icon: farPlus,
        classNames: ['far', 'plus'],
    },
    minusRegular: {
        icon: farMinus,
        classNames: ['far', 'minus'],
    },
    'add-l': {
        icon: falPlus,
        classNames: ['fal', 'plus'],
    },
    checkboxOn: {
        icon: falCheckSquare,
        classNames: ['fal', 'check-square'],
    },
    checkboxOff: {
        icon: falSquare,
        classNames: ['fal', 'square'],
    },
    cog: {
        icon: fasCog,
        classNames: ['fas', 'cog'],
    },
    falArrowUpWideShort: {
        icon: falArrowUpWideShort,
        classNames: ['fal', 'arrow-up-wide-short'],
    },
    falArrowDownFromLine: {
        icon: falArrowDownFromLine,
        classNames: ['fal', 'arrow-down-from-line'],
    },
    falCog: {
        icon: falCog,
        classNames: ['fal', 'cog'],
    },
    falCogs: {
        icon: falCogs,
        classNames: ['fal', 'cogs'],
    },
    delete: {
        icon: falTimes,
        classNames: ['fal', 'times'],
    },
    fatTimes: {
        icon: fatTimes,
        classNames: ['fal', 'times'],
    },
    fatCommentPen: {
        icon: fatCommentPen,
        classNames: ['fat', 'comment-pen'],
    },
    ellipsisv: {
        icon: fasEllipsisV,
        classNames: ['fa', 'ellipsis-v'],
    },
    upload: {
        icon: fasUpload,
        classNames: ['fas', 'upload'],
    },
    fasUser: {
        icon: fasUser,
        classNames: ['fas', 'user'],
    },
    falUser: {
        icon: falUser,
        classNames: ['fal', 'user'],
    },
    falUserCheck: {
        icon: falUserCheck,
        classNames: ['fal', 'user-check'],
    },
    users: {
        icon: fasUsers,
        classNames: ['fas', 'users'],
    },
    falUsers: {
        icon: falUsers,
        classNames: ['fal', 'users'],
    },
    falClone: {
        icon: falClone,
        classNames: ['fal', 'clone'],
    },
    complete: {
        icon: falCheck,
        classNames: ['fal', 'check'],
    },
    cancel: {
        icon: falTimesCircle,
        classNames: ['fal', 'times-circle'],
    },
    close: {
        icon: falTimes,
        classNames: ['fal', 'times'],
    },
    clear: {
        icon: falTimes,
        classNames: ['fal', 'times'],
    },
    falSquareKanban: {
        icon: falSquareKanban,
        classNames: ['fal', 'square-kanban'],
    },
    falFileExport: {
        icon: falFileExport,
        classNames: ['fal', 'file-export'],
    },
    falFileLines: {
        icon: falFileLines,
        classNames: ['fal', 'file-lines'],
    },
    fasFileLines: {
        icon: fasFileLines,
        classNames: ['fas', 'file-lines'],
    },
    falArrowsFromLine: {
        icon: falArrowsFromLine,
        classNames: ['fal', 'arrows-from-line'],
    },
    falArrowsToLine: {
        icon: falArrowsToLine,
        classNames: ['fal', 'arrows-to-line'],
    },
    success: {
        icon: falCheckCircle,
        classNames: ['fal', 'check-circle'],
    },
    info: {
        icon: falInfoCircle,
        classNames: ['fal', 'info-circle'],
    },
    warning: {
        icon: falExclamation,
        classNames: ['fal', 'exclamation'],
    },
    fasExclamationTriangle: {
        icon: fasExclamationTriangle,
        classNames: ['fas', 'exclamation-triangle'],
    },
    error: {
        icon: falExclamationTriangle,
        classNames: ['fal', 'exclamation-triangle'],
    },
    checkboxIndeterminate: {
        icon: falMinusSquare,
        classNames: ['fal', 'minus-square'],
    },
    delimiter: {
        icon: fasCircle,
        classNames: ['fas', 'circle'],
    },
    expand: {
        icon: falfaAngleDown,
        classNames: ['fal', 'angle-down'],
    },
    menu: {
        icon: falBars,
        classNames: ['fal', 'bars'],
    },
    subgroup: {
        icon: fasCaretDown,
        classNames: ['fas', 'caret-down'],
    },
    radioOn: {
        icon: farDotCircle,
        classNames: ['far', 'dot-circle'],
    },
    radioOff: {
        icon: farCircle,
        classNames: ['far', 'circle'],
    },
    edit: {
        icon: falPen,
        classNames: ['fal', 'pen'],
    },
    ratingEmpty: {
        icon: falStar,
        classNames: ['fal', 'star'],
    },
    ratingFull: {
        icon: fasStar,
        classNames: ['fas', 'star'],
    },
    ratingHalf: {
        icon: fasStarHalf,
        classNames: ['fas', 'star-half'],
    },
    loading: {
        icon: falSync,
        classNames: ['fal', 'sync'],
    },
    first: {
        icon: falArrowToLeft,
        classNames: ['fal', 'arrow-to-left'],
    },
    last: {
        icon: falArrowToRight,
        classNames: ['fal', 'arrow-to-right'],
    },
    unfold: {
        icon: farArrowsV,
        classNames: ['far', 'arrows-v'],
    },
    file: {
        icon: falPaperclip,
        classNames: ['fal', 'paperclip'],
    },
    //Custom icons
    'fal-fa-columns': {
        icon: falfaColumns,
        classNames: ['fal', 'columns'],
    },
    storiesOnBoardIcon: {
        icon: falfaGameBoardAlt,
        classNames: ['fal', 'game-board-alt'],
    },
    falfaPlusOctagon: {
        icon: falfaPlusOctagon,
        classNames: ['fal', 'plus-octagon'],
    },
    falCompress: {
        icon: falCompress,
        classNames: ['fal', 'compress'],
    },
    falExpand: {
        icon: falExpand,
        classNames: ['fal', 'expand'],
    },
    falBell: {
        icon: falBell,
        classNames: ['fal', 'bell'],
    },
    farBell: {
        icon: farBell,
        classNames: ['far', 'bell'],
    },
    falEye: {
        icon: falEye,
        classNames: ['fal', 'eye'],
    },
    fasEye: {
        icon: fasEye,
        classNames: ['fas', 'eye'],
    },
    fasMagic: {
        icon: fasMagic,
        classNames: ['fas', 'magic'],
    },
    fasHandPaper: {
        icon: fasHandPaper,
        classNames: ['fas', 'hand-paper'],
    },
    falEyeSlash: {
        icon: falEyeSlash,
        classNames: ['fal', 'eye-slash'],
    },
    farEyeSlash: {
        icon: farEyeSlash,
        classNames: ['far', 'eye-slash'],
    },
    farEye: {
        icon: farEye,
        classNames: ['far', 'eye'],
    },
    falGlobe: {
        icon: falGlobe,
        classNames: ['fal', 'globe'],
    },
    farGlobe: {
        icon: farGlobe,
        classNames: ['far', 'globe'],
    },
    falUserFriends: {
        icon: falUserFriends,
        classNames: ['fal', 'user-friends'],
    },
    fasUserFriends: {
        icon: fasUserFriends,
        classNames: ['fa', 'user-friends'],
    },
    farUserFriends: {
        icon: farUserFriends,
        classNames: ['far', 'user-friends'],
    },
    falThumbtack: {
        icon: falThumbtack,
        classNames: ['fal', 'thumbtack'],
    },
    fasThumbtack: {
        icon: fasThumbtack,
        classNames: ['fas', 'thumbtack'],
    },
    farThumbsUp: {
        icon: farThumbsUp,
        classNames: ['far', 'thumbs-up'],
    },
    falThumbsUp: {
        icon: falThumbsUp,
        classNames: ['fal', 'thumbs-up'],
    },
    falThumbsDown: {
        icon: falThumbsDown,
        classNames: ['fal', 'thumbs-down'],
    },
    farArrowsLeftRightToLine: {
        icon: farArrowsLeftRightToLine,
        classNames: ['far', 'arrows-left-right-to-line'],
    },
    farMagnifyingGlassMinus: {
        icon: farMagnifyingGlassMinus,
        classNames: ['far', 'magnifying-glass-minus'],
    },
    farMagnifyingGlassPlus: {
        icon: farMagnifyingGlassPlus,
        classNames: ['far', 'magnifying-glass-plus'],
    },
    farStar: {
        icon: farStar,
        classNames: ['far', 'star'],
    },
    fasStar: {
        icon: fasStar,
        classNames: ['fas', 'star'],
    },
    farHomeAlt: {
        icon: farHomeAlt,
        classNames: ['far', 'home-alt'],
    },
    farExpandWide: {
        icon: farExpandWide,
        classNames: ['far', 'expand-wide'],
    },
    farClock: {
        icon: farClock,
        classNames: ['far', 'clock'],
    },
    farClockRotateLeft: {
        icon: farClockRotateLeft,
        classNames: ['far', 'clock-rotate-left'],
    },
    fasUserTimes: {
        icon: fasUserTimes,
        classNames: ['fas', 'user-times'],
    },
    fasUnlockAlt: {
        icon: fasUnlockAlt,
        classNames: ['fas', 'unlock-alt'],
    },
    farUnlock: {
        icon: farUnlock,
        classNames: ['far', 'unlock'],
    },
    farLock: {
        icon: farLock,
        classNames: ['far', 'lock'],
    },
    fabSlack: {
        icon: fabSlack,
        classNames: ['fab', 'slack'],
    },
    fabJira: {
        icon: fabJira,
        classNames: ['fab', 'jira'],
    },
    fabGithub: {
        icon: fabGithub,
        classNames: ['fab', 'github'],
    },
    fabTrello: {
        icon: fabTrello,
        classNames: ['fab', 'trello'],
    },
    fabMicrosoft: {
        icon: fabMicrosoft,
        classNames: ['fab', 'microsoft'],
    },
    farEnvelope: {
        icon: farEnvelope,
        classNames: ['far', 'envelope'],
    },
    falEnvelope: {
        icon: falEnvelope,
        classNames: ['fal', 'envelope'],
    },
    falSignOutAlt: {
        icon: falSignOutAlt,
        classNames: ['fal', 'sign-out-alt'],
    },
    farGraduationCap: {
        icon: farGraduationCap,
        classNames: ['far', 'graduation-cap'],
    },
    falGraduationCap: {
        icon: falGraduationCap,
        classNames: ['fal', 'graduation-cap'],
    },
    falPlusCircle: {
        icon: falPlusCircle,
        classNames: ['fal', 'plus-circle'],
    },
    falServer: {
        icon: falServer,
        classNames: ['fal', 'server'],
    },
    fasCertificate: {
        icon: fasCertificate,
        classNames: ['fas', 'certificate'],
    },
    falKey: {
        icon: falKey,
        classNames: ['fal', 'key'],
    },
    fasKey: {
        icon: fasKey,
        classNames: ['fas', 'key'],
    },
    falIcons: {
        icon: falIcons,
        classNames: ['fal', 'icons'],
    },
    falCopy: {
        icon: falCopy,
        classNames: ['fal', 'copy'],
    },
    fasFileSpreadsheet: {
        icon: fasFileSpreadsheet,
        classNames: ['fas', 'file-spreadsheet'],
    },
    falFileSpreadsheet: {
        icon: falFileSpreadsheet,
        classNames: ['fal', 'file-spreadsheet'],
    },
    falUsersClass: {
        icon: falUsersClass,
        classNames: ['fal', 'users-class'],
    },
    falSearch: {
        icon: falSearch,
        classNames: ['fal', 'search'],
    },
    falLockAlt: {
        icon: falLockAlt,
        classNames: ['fal', 'lock-alt'],
    },
    falUnLockAlt: {
        icon: falUnLockAlt,
        classNames: ['fal', 'unlock-alt'],
    },
    falEllipsisH: {
        icon: falEllipsisH,
        classNames: ['fal', 'ellipsis-h'],
    },
    falEllipsisV: {
        icon: falEllipsisV,
        classNames: ['fal', 'ellipsis-v'],
    },
    falTrashAlt: {
        icon: falTrashAlt,
        classNames: ['fal', 'trash-alt'],
    },
    falEdit: {
        icon: falEdit,
        classNames: ['fal', 'edit'],
    },
    falPlayCircle: {
        icon: falPlayCircle,
        classNames: ['fal', 'play-circle'],
    },
    falFolders: {
        icon: falFolders,
        classNames: ['fal', 'folders'],
    },
    farFolders: {
        icon: farFolders,
        classNames: ['far', 'folders'],
    },
    farArrowDown: {
        icon: farArrowDown,
        classNames: ['far', 'arrow-down'],
    },
    farArrowUp: {
        icon: farArrowUp,
        classNames: ['far', 'arrow-up'],
    },
    farArrowLeft: {
        icon: farArrowLeft,
        classNames: ['far', 'arrow-left'],
    },
    farArrowRight: {
        icon: farArrowRight,
        classNames: ['far', 'arrow-right'],
    },
    farArchive: {
        icon: farArchive,
        classNames: ['far', 'archive'],
    },
    farListTimeline: {
        icon: farListTimeline,
        classNames: ['far', 'list-timeline'],
    },
    fasTh: {
        icon: fasTh,
        classNames: ['fas', 'th'],
    },
    farLevelUp: {
        icon: farLevelUp,
        classNames: ['far', 'level-up'],
    },
    farSearch: {
        icon: farSearch,
        classNames: ['far', 'search'],
    },
    falFileImport: {
        icon: falFileImport,
        classNames: ['fal', 'file-import'],
    },
    falFilter: {
        icon: falFilter,
        classNames: ['fal', 'filter'],
    },
    fasFilter: {
        icon: fasFilter,
        classNames: ['fas', 'filter'],
    },
    fatSlider: {
        icon: fatSlider,
        classNames: ['fat', 'slider'],
    },
    fatSquare: {
        icon: fatSquare,
        classNames: ['fat', 'square'],
    },
    fasSquare: {
        icon: fasSquare,
        classNames: ['fas', 'square'],
    },
    fasBars: {
        icon: fasBars,
        classNames: ['fas', 'bars'],
    },
    fasSparkles: {
        icon: fasSparkles,
        classNames: ['fas', 'sparkles'],
    },
    farBars: {
        icon: farBars,
        classNames: ['far', 'bars'],
    },
    farSliders: {
        icon: farSliders,
        classNames: ['far', 'sliders'],
    },
    farKeyboardLeft: {
        icon: farKeyboardLeft,
        classNames: ['far', 'keyboard-left'],
    },
    farThumbTack: {
        icon: farThumbTack,
        classNames: ['far', 'thumb-tack'],
    },
    farUser: {
        icon: farUser,
        classNames: ['far', 'user'],
    },
    farCircleInfo: {
        icon: farCircleInfo,
        classNames: ['far', 'circle-info'],
    },
    farTag: {
        icon: farTag,
        classNames: ['far', 'tag'],
    },
    falCloud: {
        icon: falCloud,
        classNames: ['fal', 'cloud'],
    },
    fasChalkboardTeacher: {
        icon: fasChalkboardTeacher,
        classNames: ['fas', 'chalkboard-teacher'],
    },
    fasBinoculars: {
        icon: fasBinoculars,
        classNames: ['fas', 'binoculars'],
    },
    fasLayerGroup: {
        icon: fasLayerGroup,
        classNames: ['fas', 'layer-group'],
    },
    fasPlug: {
        icon: fasPlug,
        classNames: ['fas', 'plug'],
    },
    fasCommentCheck: {
        icon: fasCommentCheck,
        classNames: ['fas', 'comment-check'],
    },
    falReply: {
        icon: falReply,
        classNames: ['fal', 'reply'],
    },
    falPaperPlane: {
        icon: falPaperPlane,
        classNames: ['fal', 'paper-plane'],
    },
    falUserHeadset: {
        icon: falUserHeadset,
        classNames: ['fal', 'user-headset'],
    },
    falUserCog: {
        icon: falUserCog,
        classNames: ['fal', 'user-cog'],
    },
    falSlidersVSquare: {
        icon: falSlidersVSquare,
        classNames: ['fal', 'sliders-v-square'],
    },
    falFileInvoiceDollar: {
        icon: falFileInvoiceDollar,
        classNames: ['fal', 'file-invoice-dollar'],
    },
    falUserPlus: {
        icon: falUserPlus,
        classNames: ['fal', 'user-plus'],
    },
    falTag: {
        icon: falTag,
        classNames: ['fal', 'tag'],
    },
    falPaintBrushFine: {
        icon: falPaintBrushFine,
        classNames: ['fal', 'paint-brush-fine'],
    },
    falAlignJustify: {
        icon: falAlignJustify,
        classNames: ['fal', 'align-justify'],
    },
    falTimer: {
        icon: falTimer,
        classNames: ['fal', 'timer'],
    },
    falCalendarCircleMinus: {
        icon: falCalendarCircleMinus,
        classNames: ['fal', 'calendar-circle-minus'],
    },
    fasCrown: {
        icon: fasCrown,
        classNames: ['fas', 'crown'],
    },
    fadGrinHearts: {
        icon: fadGrinHearts,
        classNames: ['fad', 'grin-hearts'],
    },
    fadFileInvoice: {
        icon: fadFileInvoice,
        classNames: ['fad', 'file-invoice'],
    },
    falCommentSmile: {
        icon: falCommentSmile,
        classNames: ['fal', 'comment-smile'],
    },
    falBuilding: {
        icon: falBuilding,
        classNames: ['fal', 'building'],
    },
    falBuildings: {
        icon: falBuildings,
        classNames: ['fal', 'buildings'],
    },
    fadBullhorn: {
        icon: fadBullhorn,
        classNames: ['fad', 'bullhorn'],
    },
    fasList: {
        icon: fasList,
        classNames: ['fas', 'list'],
    },
    fasListOl: {
        icon: fasListOl,
        classNames: ['fas', 'list-ol'],
    },
    falGripHorizontal: {
        icon: falGripHorizontal,
        classNames: ['fal', 'grip-horizontal'],
    },
    falLink: {
        icon: falLink,
        classNames: ['fal', 'link'],
    },
    falLinkSlash: {
        icon: falLinkSlash,
        classNames: ['fal', 'link-slash'],
    },
    falUserSlash: {
        icon: falUserSlash,
        classNames: ['fal', 'user-slash'],
    },
    falFolder: {
        icon: falFolder,
        classNames: ['fal', 'folder'],
    },
    farFolder: {
        icon: farFolder,
        classNames: ['far', 'folder'],
    },
    fasUserLock: {
        icon: fasUserLock,
        classNames: ['fas', 'user-lock'],
    },
    falShare: {
        icon: falShare,
        classNames: ['fal', 'share-alt'],
    },
    falShareFromSquare: {
        icon: falShareFromSquare,
        classNames: ['fal', 'share-from-square'],
    },
    fasGripVertical: {
        icon: fasGripVertical,
        classNames: ['fas', 'grip-vertical'],
    },
    falArrowRight: {
        icon: falArrowRight,
        classNames: ['fal', 'arrow-right'],
    },
    fasShareSquare: {
        icon: fasShareSquare,
        classNames: ['fas', 'share-square'],
    },
    falChartGantt: {
        icon: falChartGantt,
        classNames: ['fal', 'chart-gantt'],
    },
    fatSquarePlus: {
        icon: fatSquarePlus,
        classNames: ['fat', 'square-plus'],
    },
    fatUpRight: {
        icon: fatUpRight,
        classNames: ['fat', 'up-right'],
    },
    fatDownRight: {
        icon: fatDownRight,
        classNames: ['fat', 'down-right'],
    },
    falChevronsLeft: {
        icon: falChevronsLeft,
        classNames: ['fal', 'chevrons-left'],
    },
    falChevronsRight: {
        icon: falChevronsRight,
        classNames: ['fal', 'chevrons-right'],
    },
    falFileInvoice: {
        icon: falFileInvoice,
        classNames: ['fal', 'file-invoice'],
    },
    farGripDots: {
        icon: farGripDots,
        classNames: ['far', 'grip-dots'],
    },
    farMessageDots: {
        icon: farMessageDots,
        classNames: ['far', 'message-dots'],
    },
    farArrowUpWideShort: {
        icon: farArrowUpWideShort,
        classNames: ['far', 'arrow-up-wide-short'],
    },
    farCircleXmark: {
        icon: farCircleXmark,
        classNames: ['far', 'circle-xmark'],
    },
    farChevronUp: {
        icon: farChevronUp,
        classNames: ['far', 'chevron-up'],
    },
    farChevronDown: {
        icon: farChevronDown,
        classNames: ['far', 'chevron-down'],
    },
    farChevronsUp: {
        icon: farChevronsUp,
        classNames: ['far', 'chevrons-up'],
    },
    farCircle: {
        icon: farCircle,
        classNames: ['far', 'circle'],
    },
    farTimer: {
        icon: farTimer,
        classNames: ['far', 'timer'],
    },
    farCircleExclamation: {
        icon: farCircleExclamation,
        classNames: ['far', 'circle-exclamation'],
    },
    farChartLineUp: {
        icon: farChartLineUp,
        classNames: ['far', 'chart-line-up'],
    },
    farFaceSmile: {
        icon: farFaceSmile,
        classNames: ['far', 'face-smile'],
    },
    farFaceMeh: {
        icon: farFaceMeh,
        classNames: ['far', 'face-meh'],
    },
    farFaceFrown: {
        icon: farFaceFrown,
        classNames: ['far', 'face-frown'],
    },
    farCaretRight: {
        icon: farCaretRight,
        classNames: ['far', 'caret-right'],
    },
    farCircleEllipsis: {
        icon: farCircleEllipsis,
        classNames: ['far', 'circle-ellipsis'],
    },
    farArrowsToLine: {
        icon: farArrowsToLine,
        classNames: ['far', 'arrows-to-line'],
    },
    farArrowsFromLine: {
        icon: farArrowsFromLine,
        classNames: ['far', 'arrows-from-line'],
    },
    farRotate: {
        icon: farRotate,
        classNames: ['far', 'rotate'],
    },
    farLightbulb: {
        icon: farLightbulb,
        classNames: ['far', 'lightbulb'],
    },
    falRectangleList: {
        icon: falRectangleList,
        classNames: ['fal', 'rectangle-list'],
    },
    falRocket: {
        icon: falRocket,
        classNames: ['fal', 'rocket'],
    },
    fatRocketLaunch: {
        icon: fatRocketLaunch,
        classNames: ['fat', 'rocket-launch'],
    },
    farUserLock: {
        icon: farUserLock,
        classNames: ['far', 'user-lock'],
    },
    farUserCheck: {
        icon: farUserCheck,
        classNames: ['far', 'user-check'],
    },
    farArrowRightToLine: {
        icon: farArrowRightToLine,
        classNames: ['far', 'arrow-right-to-line'],
    },
    farBook: {
        icon: farBook,
        classNames: ['far', 'book'],
    },
    farFilter: {
        icon: farFilter,
        classNames: ['far', 'filter'],
    },
    farRectangleList: {
        icon: farRectangleList,
        classNames: ['far', 'rectangle-list'],
    },
    farPause: {
        icon: farPause,
        classNames: ['far', 'pause'],
    },
    farPlay: {
        icon: farPlay,
        classNames: ['far', 'play'],
    },
    farArrowsRotate: {
        icon: farArrowsRotate,
        classNames: ['far', 'arrows-rotate'],
    },
    farLinkSlash: {
        icon: farLinkSlash,
        classNames: ['far', 'link-slash'],
    },
    farCloudArrowUp: {
        icon: farCloudArrowUp,
        classNames: ['far', 'cloud-arrow-up'],
    },
    falArrowsUpDown: {
        icon: falArrowsUpDown,
        classNames: ['fal', 'arrows-up-down'],
    },
    falArrowsLeftRight: {
        icon: falArrowsLeftRight,
        classNames: ['fal', 'arrows-left-right'],
    },
    falArrowProgress: {
        icon: falArrowProgress,
        classNames: ['fal', 'arrow-progress'],
    },
    falTrashCan: {
        icon: falTrashCan,
        classNames: ['fal', 'trash-can'],
    },
    farArrowRightLongToLine: {
        icon: farArrowRightLongToLine,
        classNames: ['far', 'arrow-right-long-to-line'],
    },
    farArrowUpToLine: {
        icon: farArrowUpToLine,
        classNames: ['far', 'arrow-up-to-line'],
    },
    farListUl: {
        icon: farListUl,
        classNames: ['far', 'list-ul'],
    },
    falArrowsToDot: {
        icon: falArrowsToDot,
        classNames: ['fal', 'arrows-to-dot'],
    },
    falArrowDownLeftAndArrowUpRightToCenter: {
        icon: falArrowDownLeftAndArrowUpRightToCenter,
        classNames: ['fal', 'arrow-down-left-and-arrow-up-right-to-center'],
    },
    falArrowUpRight: {
        icon: falArrowUpRight,
        classNames: ['fal', 'arrow-up-right'],
    },
    falUpRight: {
        icon: falUpRight,
        classNames: ['fal', 'up-right'],
    },
    falArrowsLeftRightToLine: {
        icon: falArrowsLeftRightToLine,
        classNames: ['fal', 'arrows-left-right-to-line'],
    },
    falNoteSticky: {
        icon: falNoteSticky,
        classNames: ['fal', 'note-sticky'],
    },
    falCommentPen: {
        icon: falCommentPen,
        classNames: ['fal', 'comment-pen'],
    },
    farBold: {
        icon: farBold,
        classNames: ['far', 'bold'],
    },
    farItalic: {
        icon: farItalic,
        classNames: ['far', 'italic'],
    },
    farUnderline: {
        icon: farUnderline,
        classNames: ['far', 'underline'],
    },
    farStrikethrough: {
        icon: farStrikethrough,
        classNames: ['far', 'strikethrough'],
    },
    farCode: {
        icon: farCode,
        classNames: ['far', 'code'],
    },
    farFileCode: {
        icon: farFileCode,
        classNames: ['far', 'file-code'],
    },
    farParagraph: {
        icon: farParagraph,
        classNames: ['far', 'paragraph'],
    },
    farH1: {
        icon: farH1,
        classNames: ['far', 'h1'],
    },
    farH2: {
        icon: farH2,
        classNames: ['far', 'h2'],
    },
    farH3: {
        icon: farH3,
        classNames: ['far', 'h3'],
    },
    farH4: {
        icon: farH4,
        classNames: ['far', 'h4'],
    },
    farH5: {
        icon: farH5,
        classNames: ['far', 'h5'],
    },
    farFilePlusMinus: {
        icon: farFilePlusMinus,
        classNames: ['far', 'file-plus-minus'],
    },
    fasBold: {
        icon: fasBold,
        classNames: ['fas', 'bold'],
    },
    fasItalic: {
        icon: fasItalic,
        classNames: ['fas', 'italic'],
    },
    fasUnderline: {
        icon: fasUnderline,
        classNames: ['fas', 'underline'],
    },
    fasStrikethrough: {
        icon: fasStrikethrough,
        classNames: ['fas', 'strikethrough'],
    },
    fasCode: {
        icon: fasCode,
        classNames: ['fas', 'code'],
    },
    fasParagraph: {
        icon: fasParagraph,
        classNames: ['fas', 'paragraph'],
    },
    fasH1: {
        icon: fasH1,
        classNames: ['fas', 'h1'],
    },
    fasH2: {
        icon: fasH2,
        classNames: ['fas', 'h2'],
    },
    fasH3: {
        icon: fasH3,
        classNames: ['fas', 'h3'],
    },
    fasH4: {
        icon: fasH4,
        classNames: ['fas', 'h4'],
    },
    fasH5: {
        icon: fasH5,
        classNames: ['fas', 'h5'],
    },
    fasQuoteLeft: {
        icon: fasQuoteLeft,
        classNames: ['fas', 'quote-left'],
    },
    fasHorizontalRule: {
        icon: fasHorizontalRule,
        classNames: ['fas', 'horizontal-rule'],
    },
    fasRotateLeft: {
        icon: fasRotateLeft,
        classNames: ['fas', 'rotate-left'],
    },
    fasRotateRight: {
        icon: fasRotateRight,
        classNames: ['fas', 'rotate-right'],
    },
    fasListCheck: {
        icon: fasListCheck,
        classNames: ['fas', 'list-check'],
    },
    faslBold: {
        icon: faslBold,
        classNames: ['fasl', 'bold'],
    },
    faslItalic: {
        icon: faslItalic,
        classNames: ['fasl', 'italic'],
    },
    faslUnderline: {
        icon: faslUnderline,
        classNames: ['fasl', 'underline'],
    },
    faslStrikethrough: {
        icon: faslStrikethrough,
        classNames: ['fasl', 'strikethrough'],
    },
    faslCode: {
        icon: faslCode,
        classNames: ['fasl', 'code'],
    },
    faslParagraph: {
        icon: faslParagraph,
        classNames: ['fasl', 'paragraph'],
    },
    faslH1: {
        icon: faslH1,
        classNames: ['fasl', 'h1'],
    },
    faslH2: {
        icon: faslH2,
        classNames: ['fasl', 'h2'],
    },
    faslH3: {
        icon: faslH3,
        classNames: ['fasl', 'h3'],
    },
    faslH4: {
        icon: faslH4,
        classNames: ['fasl', 'h4'],
    },
    faslH5: {
        icon: faslH5,
        classNames: ['fasl', 'h5'],
    },
    faslQuoteLeft: {
        icon: faslQuoteLeft,
        classNames: ['fasl', 'quote-left'],
    },
    faslHorizontalRule: {
        icon: faslHorizontalRule,
        classNames: ['fasl', 'horizontal-rule'],
    },
    faslRotateLeft: {
        icon: faslRotateLeft,
        classNames: ['fasl', 'rotate-left'],
    },
    faslRotateRight: {
        icon: faslRotateRight,
        classNames: ['fasl', 'rotate-right'],
    },
    faslListCheck: {
        icon: faslListCheck,
        classNames: ['fasl', 'list-check'],
    },
    faslList: {
        icon: faslList,
        classNames: ['fasl', 'list'],
    },
    faslListOl: {
        icon: faslListOl,
        classNames: ['fasl', 'list-ol'],
    },
    faslPlus: {
        icon: faslPlus,
        classNames: ['fasl', 'plus'],
    },
    faslImage: {
        icon: faslImage,
        classNames: ['fasl', 'image'],
    },
    fasrBold: {
        icon: fasrBold,
        classNames: ['fasr', 'bold'],
    },
    fasrItalic: {
        icon: fasrItalic,
        classNames: ['fasr', 'italic'],
    },
    fasrUnderline: {
        icon: fasrUnderline,
        classNames: ['fasr', 'underline'],
    },
    fasrStrikethrough: {
        icon: fasrStrikethrough,
        classNames: ['fasr', 'strikethrough'],
    },
    fasrCode: {
        icon: fasrCode,
        classNames: ['fasr', 'code'],
    },
    fasrParagraph: {
        icon: fasrParagraph,
        classNames: ['fasr', 'paragraph'],
    },
    fasrH1: {
        icon: fasrH1,
        classNames: ['fasr', 'h1'],
    },
    fasrH2: {
        icon: fasrH2,
        classNames: ['fasr', 'h2'],
    },
    fasrH3: {
        icon: fasrH3,
        classNames: ['fasr', 'h3'],
    },
    fasrH4: {
        icon: fasrH4,
        classNames: ['fasr', 'h4'],
    },
    fasrH5: {
        icon: fasrH5,
        classNames: ['fasr', 'h5'],
    },
    fasrQuoteLeft: {
        icon: fasrQuoteLeft,
        classNames: ['fasr', 'quote-left'],
    },
    fasrHorizontalRule: {
        icon: fasrHorizontalRule,
        classNames: ['fasr', 'horizontal-rule'],
    },
    fasrRotateLeft: {
        icon: fasrRotateLeft,
        classNames: ['fasr', 'rotate-left'],
    },
    fasrRotateRight: {
        icon: fasrRotateRight,
        classNames: ['fasr', 'rotate-right'],
    },
    fasrListCheck: {
        icon: fasrListCheck,
        classNames: ['fasr', 'list-check'],
    },
    fasrList: {
        icon: fasrList,
        classNames: ['fasr', 'list'],
    },
    fasrListOl: {
        icon: fasrListOl,
        classNames: ['fasr', 'list-ol'],
    },
    fabMarkdown: {
        icon: fabMarkdown,
        classNames: ['fab', 'markdown'],
    },
    faslLink: {
        icon: faslLink,
        classNames: ['fasl', 'link'],
    },
    faslArrowUpRightFromSquare: {
        icon: faslArrowUpRightFromSquare,
        classNames: ['fasl', 'arrow-up-right-from-square'],
    },
    faslLinkSlash: {
        icon: faslLinkSlash,
        classNames: ['fasl', 'link-slash'],
    },
    faslVideo: {
        icon: faslVideo,
        classNames: ['fasl', 'video'],
    },
    falCrosshairs: {
        icon: falCrosshairs,
        classNames: ['fal', 'crosshairs'],
    },
    falArrowTurnRight: {
        icon: falArrowTurnRight,
        classNames: ['fal', 'arrow-turn-right'],
    },
    fasNoteSticky: {
        icon: fasNoteSticky,
        classNames: ['fas', 'note-sticky'],
    },
    faslCommentLines: {
        icon: faslCommentLines,
        classNames: ['fasl', 'comment-lines'],
    },
    faslCheck: {
        icon: faslCheck,
        classNames: ['fasl', 'check'],
    },
    faslXmark: {
        icon: faslXmark,
        classNames: ['fasl', 'xmark'],
    },
    faslFloppyDisk: {
        icon: faslFloppyDisk,
        classNames: ['fasl', 'floppy-disk'],
    },
    faslPenToSquare: {
        icon: faslPenToSquare,
        classNames: ['fasl', 'pen-to-square'],
    },
    fasCheckCircle: {
        icon: fasCheckCircle,
        classNames: ['fas', 'check-circle'],
    },
    fasShieldAlt: {
        icon: fasShieldAlt,
        classNames: ['fas', 'shield-alt'],
    },
    falCodeCompare: {
        icon: falCodeCompare,
        classNames: ['fal', 'code-compare'],
    },
};

export { iconList };
